var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isApiLoading)?_c('div',{staticClass:"loader"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"#10DF34","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }